// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"ce7a4861","234":"6ff73112","349":"e7484dc3","541":"8ccef250","810":"4caae1f5","823":"f82c0c81"}[chunkId] + ".chunk.js";
};